































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import {ActionsEnum} from "@/entity/ActionsEnum";
import Decimal from "@/components/inputs/Decimal.vue";
import ImageShow from "@/components/ImageShow.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";
export class config {
    phone : String = "";
    phone2 : String = "";
    address : String = "";
    address2 : String = "";
    email : String = "";
    instagram : String = "";
    facebook : String = "";
    watsappNo: String = "";
    contactInfo : String = "";
    contactInfo_en : String = "";
    bannerSlogan : String = "";
    bannerSlogan_en : String = "";
    bannerAltSlogan : String = "";
    bannerAltSlogan_en : String = "";
    analytics   : String = "";
    remarketing   : String = "";
    anasayfaBaslik   : String = "";
    anasayfaBaslik_en   : String = "";
    anasayfaSlogan   : String = "";
    anasayfaSlogan_en   : String = "";
}
@Component({
    components: {
        ImageUpload,
        ImageShow,
        Decimal,
        DeleteButton,EForm,Number,TextField,EnabledSwitch
    }
})
export default class SiteConfig extends  Vue{
    baseAction : string = ActionsEnum.Config;
    action : string = this.baseAction;
    data : config = new config();
    requestPayload : any = {
        file:!File
    }
    randomNumber : number = 1;
    async get(){
        let response = await this.$http.get(this.action);
        this.data = response.data;
    }
    created(){
        this.get();
    }
};
